<template>
  <div class="myxcxset">
    <headBox type="1">
      <span class="icon green"><i class="icon-xiaochengxu"></i></span>
      <div class="text-box">
        <div class="text1">管理小程序模板</div>
        <div class="text2">您可在微信文章内容以及微信公众号自定义菜单等场景插入您的专属小程序；利用小程序的入口优势进行推广（模板内保险产品均为机构专属投保地址）</div>
      </div>
    </headBox>
    <div class="main-content">
      <div class="conten-text">
        <h3>使用方式</h3>
        <div class="text">
          1、您可以直接使用系统配置的模板进行推广，若您需自定义模板内容，可点击下方左侧新增自定义小程序模板。<br />
          2、在公众号菜单/文章中选择小程序，并在操作界面直接搜索“精品保险汇”；<br />
          3、务必把<span class="red">默认的小程序路径修改为您当前需要使用的小程序路径。</span><br />
        </div>
        <h3>应用场景</h3>
        <div class="text">
          1、您可以将您的小程序店铺，嵌入到您的微信公众号菜单中，方便客户打开。<br />
          2、您可以将您需要推广的保险产品的二维码/小程序插入文章中，客户通过小程序打开产品页面，完成投保交易。
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="我的小程序" name="first">
          <templateList ref="templateListRef" :blankFlage="blankFlage"></templateList>
        </el-tab-pane>
        <el-tab-pane label="商品/服务路径" name="second">
          <div class="second-box">
            <h3>
              说明：您可将以下商品或服务路径单独嵌入到您的微信公众号文章和微信公众号菜单中。
            </h3>
            <div class="wrapper-1">
              <div class="wrapper-2">
                <img src="@static/images/webset/webset01.png" alt="">
                <div class="title">商品路径</div>
                <div class="description">
                  可将单款商品以小程序的方式嵌入文章中，客户打开将直达商品详情页面
                </div>
                <div class="link">
                  <span @click="LinkFn(1)">前往我的商品列表，查看商品的小程序路径 ></span>
                </div>
              </div>
              <div class="wrapper-2">
                <img src="@static/images/webset/webset02.png" alt="">
                <div class="title">保单管家</div>
                <div class="description">
                  精准解析分类保单，提供保单到期、续费等提醒服务。
                </div>
                <div class="link">
                  <span @click="LinkFn(2)" class="copy1">复制小程序路径</span>
                  <span @click="LinkFn(3)">下载小程序二维码</span>
                </div>
              </div>
              <div class="wrapper-2">
                <img src="@static/images/webset/webset03.png" alt="">
                <div class="title">预核保</div>
                <div class="description">
                  结合全量疾病核保知识库，根据用户患病情况，筛选可投保的好产品。
                </div>
                <div class="link">
                  <span @click="LinkFn(4)" class="copy2">复制小程序路径</span>
                  <span @click="LinkFn(5)">下载小程序二维码</span>
                </div>
              </div>
              <div class="wrapper-2">
                <img src="@static/images/webset/webset04.png" alt="">
                <div class="title">我的（个人中心）</div>
                <div class="description">
                  用户可以通过该入口查看保单、理赔进度、保障分析以及保单验真。
                </div>
                <div class="link">
                  <span @click="LinkFn(6)" class="copy3">复制小程序路径</span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
//当前实例组件
import headBox from '@/components/head2.vue'
import Clipboard from 'clipboard'
import common from '../../api/common.js'
import templateList from './component/templateList.vue'
export default {
  data: () => ({
    activeName: 'first',
    downloadImg: '', //预核保
    bdgjImg: '', //保单管家
    yygwImg: '', //预约顾问
    indexImg: '', //投保小程序首页
    mainInfo: {},
    blankFlage: '',
  }),
  components: { headBox, templateList },
  created() {
    this.queryMechanInfo()
    this.blankFlage = this.$route.query.websiteType
  },
  methods: {
    // 投保小程序
    queryQrCode(type, params) {
      this.$http({
        url: '/api/webappInsure/qrCode',
        type: 'post',
        params: params,
      }).then((data)=> {
        if (type == 'index') {
          this.indexImg = this.$config.api_root + data.data
        } else if (type == 'bdgj') {
          this.bdgjImg = this.$config.api_root + data.data
        } else if (type == 'yygw') {
          this.yygwImg = this.$config.api_root + data.data
        }
      })
    },
    // 核保助手
    hbQrCode() {
      this.$http({
        url: '/api/hbzs/qrCode',
        type: 'post',
        params: {
          mechanCode: this.mainInfo.code,
          scene: this.mainInfo.code,
        },
      }).then((data)=> {
        this.downloadImg = this.$config.api_root + data.data
      })
    },
    LinkFn(type) {
      if (type == 1) {
        this.$router.push('/productlibrary')
      }
      //保单管家
      if (type == 2) {
        this.copy('pages/web?scene=' + this.mainInfo.code + '$bdgj', '.copy1')
      }
      if (type == 3) {
        this.download(this.bdgjImg, '')
      }
      //预核保
      if (type == 4) {
        this.copy('pages/index/index?scene=' + this.mainInfo.code, '.copy2')
      }
      if (type == 5) {
        this.download(this.downloadImg, '')
      }
      if (type == 6) {
        this.copy('pages/personal?scene=' + this.mainInfo.code, '.copy3')
      }
      //预约顾问
      if (type == 7) {
        this.copy('pages/appointment?scene=' + this.mainInfo.code, '.copy4')
      }
      if (type == 8) {
        this.download(this.yygwImg, '')
      }
    },
    copy: function (link, id) {
      var that = this
      var clipboard = new Clipboard(id, {
        text: function () {
          return link
        },
      })
      clipboard.on('success', function (e) {
        that.linkVisible = false
        that.$message({
          message: '复制成功',
          type: 'success',
        })
        clipboard.destroy()
      })
    },
    download: function (url, name) {
      console.log(url)
      var a = document.createElement('a')
      a.href = url
      a.download = ''
      a.click()
    },
    handleClick(tab, event) {
      console.log(tab, event)
    },
    queryMechanInfo: function () {
      var that = this
      this.$http({
        url: '/master/mechan/queryMechanInfo',
        type: 'put',
        params: {},
      }).then(function (data) {
        that.mainInfo = data.data
        that.$tools.setLocal('queryMechanInfo', data.data, 1)
        // 投保小程序 保单管家
        that.queryQrCode('bdgj', {
          scene: that.mainInfo.code + '$bdgj',
          page: 'pages/web',
        })
        // 投保小程序 预约顾问
        that.queryQrCode('yygw', {
          scene: that.mainInfo.code + '$yygw',
          page: 'pages/appointment',
        })
        that.hbQrCode()
      })
    },
    goPhoneSet: function (flage) {
      this.$router.push({ path: '/myphone', query: { websiteType: flage } })
    },
  },
}
</script>
<style lang="scss">
@import './myxcxset';
</style>
